import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=0686826a&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=0686826a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686826a",
  null
  
)

export default component.exports